import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Button from 'react-bootstrap/Button';
import './CarouselSection.css';

function CarouselSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Carousel className="full-width-carousel" controls={false} interval={4000}>
        <Carousel.Item>
        <div className="carousel-image-container">
          <img
            className="d-block carousel-image"
            src="problems.webp"
            alt="Data-Driven Success"
          />
        </div>
        <Carousel.Caption>
          <h1 className="carousel-title">What Keeps You Up at Night?</h1>
          <Button variant="light" size="lg" className="carousel-button" onClick={scrollToContact}>
            Schedule Free Strategy Session
          </Button>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <div className="carousel-image-container">
          <img
            className="d-block carousel-image"
            src="hero3.webp"
            alt="Data-Driven Success"
          />
        </div>
        <Carousel.Caption>
          <h1 className="carousel-title">Transform Your Business with AI Solutions That Deliver Measurable Impact</h1>
          <Button variant="light" size="lg" className="carousel-button" onClick={scrollToContact}>
            Schedule Free Consult
          </Button>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <div className="carousel-image-container">
          <img
            className="d-block carousel-image"
            src="hero2.webp"
            alt="Your Dream Mentorship Team"
          />
        </div>
        <Carousel.Caption>
          <h1 className="carousel-title">What is Your AI Ambition?</h1>
          <Button variant="light" size="lg" className="carousel-button" onClick={scrollToContact}>
            Attian Your Ambition
          </Button>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default CarouselSection;
